<template>
  <div class="home">
    <Art @open-form="showForm = true" />
    <Form :show="showForm" @close="showForm = false" />
  </div>
</template>

<script>
import Art from "@/components/Art.vue";
import Form from "@/components/Form.vue";

export default {
  name: "Home",
  components: { Art, Form },
  data() {
    return { showForm: false };
  },
};
</script>
